module.exports = __webpack_public_path__ + "static/media/sheild-dynamic-premium.1da9f3bb.png";